export const farmersBeanSeatCoordinates = [
  /** Left */
  ...[...new Array(5).keys()].map((y) => ({ x: 0.7, y: y + 0.4 })),
  ...[...new Array(4).keys()].map((y) => ({ x: 2.7, y: y + 0.5 })),
  ...[...new Array(2).keys()].map((y) => ({ x: 2.7, y: y + 5 })),
  ...[...new Array(7).keys()].map((y) => ({ x: 2.7, y: y + 7.3 })),

  /** Center */
  ...[...new Array(4).keys()].map((y) => ({ x: 4.7, y: y + 3.4 })),

  ...[...new Array(1).keys()].map((y) => ({ x: 9.5, y: y + 3 })),
  ...[...new Array(2).keys()].map((y) => ({ x: 12, y: y + 3 })),
  ...[...new Array(2).keys()].map((y) => ({ x: 14.5, y: y + 3 })),
  ...[...new Array(2).keys()].map((y) => ({ x: 12, y: y + 5.5 })),
  ...[...new Array(2).keys()].map((y) => ({ x: 14.5, y: y + 5.5 })),

  ...[...new Array(1).keys()].map((y) => ({ x: 14.5, y: y + 8.6 })),

  /** Right */
  ...[...new Array(3).keys()].map((y) => ({ x: 18.8, y: y + 1 })),
  ...[...new Array(3).keys()].map((y) => ({ x: 18.8, y: y + 5.2 })),
  ...[...new Array(3).keys()].map((y) => ({ x: 18.8, y: y + 10 })),
  ...[...new Array(3).keys()].map((x) => ({ x: x + 14, y: 13 })),
].map((coordinate, index) => ({ ...coordinate, number: index + 1 }));
